import React, { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import CuroNextLogo from "../../../../assets/icons/maid-module-icons/CuroNextLogo.svg";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import DownloadIcon from "../../../../assets/icons/maid-module-icons/downloadButton.svg"

const DigitalPassCard = ({ show, onHide, staffData }) => {
  const passRef = useRef(null);
  const [downloading, setDownloading] = useState(false);

  if (!show) return null;

  // Get info from localStorage
  const userDataRaw = localStorage.getItem("userData");
  let buildingInfo = {
    buildingName: "",
    logo: null,
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
  };

  if (userDataRaw) {
    try {
      const parsed = JSON.parse(userDataRaw);
      buildingInfo = {
        buildingName: parsed.buildingName || "",
        logo: parsed.logo || null,
        addressLine1: parsed.addressLine1 || "",
        addressLine2: parsed.addressLine2 || "",
        city: parsed.city || "",
        state: parsed.state || "",
      };
    } catch (e) {
      console.error("Failed to parse userData:", e);
    }
  }

  const hasBuildingInfo = buildingInfo.buildingName || buildingInfo.logo;
  const name = staffData?.userName || staffData?.name || "—";
  const gender = staffData?.gender || "—";
  const roleName = staffData?.roleName || staffData?.role || "Staff";
  const passCode = staffData?.passCode || staffData?.curoNextId || null;

 
  const displayRole = roleName || "Staff";
  const staffGender = gender || "-";

  const qrValue =
    passCode && passCode !== "Pending Approval"
      ? String(passCode)
      : "—";

  // Profile source handling for both File and URL
let profileSrc = null;
if (staffData?.profileImage instanceof File) {
  profileSrc = URL.createObjectURL(staffData.profileImage);
} else if (staffData?.userImageURL) {
  profileSrc = staffData.userImageURL;
} else if (staffData?.profileImage) {
  profileSrc = staffData.profileImage;
}


const handleDownload = async () => {
  setDownloading(true);
  try {
    if (!passRef.current) return;

    const card = passRef.current;

    const canvas = await html2canvas(card, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    // A4 size in pt
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();   // 595
    const pageHeight = pdf.internal.pageSize.getHeight(); // 842

    // Maintain aspect ratio
    const imgWidth = pageWidth - 80; // margin left-right
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    const yPosition = (pageHeight - imgHeight) / 2; // center vertically

    pdf.addImage(
      imgData,
      "PNG",
      40,                // left margin
      yPosition > 0 ? yPosition : 40, // top margin
      imgWidth,
      imgHeight
    );

    pdf.save(
      `ServiceStaffPass_${(name || "staff").replace(/\s+/g, "_")}.pdf`
    );
  } catch (err) {
    console.error("PDF error:", err);
  } finally {
    setDownloading(false);
  }
};


  return (
    <>
      {/* Black Background with pass card */}
      <div
        onClick={onHide}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0, 0, 0, 0.2)",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          zIndex: 1120,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        {/* Pass Card Container */}
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "100%",
            maxWidth: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            ref={passRef}
            style={{
              width: "100%",
              maxWidth: 500,
              background: "#ffffff",
              borderRadius: 20,
              overflow: "hidden",
              border: "1px solid #e5e7eb",
              boxShadow: "0 12px 45px rgba(0,0,0,0.18)",
            }}
          >
            {/* Pass Header */}
            <div
              style={{
                padding: "8px 16px",
                textAlign: "center",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <h3 style={{ margin: 0, fontWeight: 700, fontSize: 17, color: "#000000" }}>
                Service Staff Pass
              </h3>
            </div>

            {/* Building */}
            {hasBuildingInfo && (
              <div
                style={{
                  padding: "8px 16px",
                  textAlign: "center",
                  background: "#FFFFFF",
                }}
              >
          {buildingInfo.logo ? (
       <img
          src={buildingInfo.logo}
          alt="Building Logo"
          style={{
            maxHeight: 55,
            width: "auto",
            maxWidth: "80%",
            objectFit: "contain",
            marginBottom: 8,
          }}
        />
          ) : (
            <div
              style={{
                fontSize: 15,
                fontWeight: 700,
                color: "#000000",
                marginBottom: 3,
              }}
            >
                    {buildingInfo.buildingName}
                  </div>
                )}

                <div style={{ fontWeight: 600, fontSize: 15, marginTop: 2, color: "#000000" }}>
                  {buildingInfo.addressLine1}
                </div>

                {buildingInfo.addressLine2 && (
                  <div style={{ fontSize: 12, color: "#6b7280", marginTop: 1 }}>
                    {buildingInfo.addressLine2}
                  </div>
                )}

                {(buildingInfo.city || buildingInfo.state) && (
                  <div style={{ fontSize: 12, color: "#6b7280", marginTop: 1 }}>
                    {buildingInfo.city}
                    {buildingInfo.city && buildingInfo.state && ", "}
                    {buildingInfo.state}
                  </div>
                )}
              </div>
            )}

            {/* Profile + QR */}
            <div
              style={{
                padding: "10px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
              }}
            >
              {/* Profile */}
              <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1 }}>
                {/* Image + Role */}
                <div style={{ textAlign: "center" }}>
                  <img
                    src={profileSrc}
                    alt="Profile"
                   
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      border: "none",
                      objectFit: "cover",
                    }}
                  />

                  <div
                    style={{
                      fontWeight: 600,
                      color: "#1C94D2",
                      marginTop: 4,
                      fontSize: 13,
                    }}
                  >
                    {displayRole}
                  </div>
                </div>

                {/* Name,Gender */}
                <div style={{ marginTop: -20 }}>
                  <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "#000000" }}>
                    {name}
                  </h3>


                 <div style={{ color: "#6b7280", fontSize: 14, marginTop: 2 }}>
                    {staffGender}
                  </div>
                </div>
              </div>

              {/* QR Code */}
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    padding: 0,
                    background: "#ffffff",
                    borderRadius: 0,
                  }}
                >
                  {qrValue !== "—" ? (
                    <QRCodeCanvas
                      value={qrValue}
                      size={90}
                      level="H"
                      fgColor="#000000"
                      bgColor="#ffffff"
                    />
                  ) : (
                    <div
                      style={{
                        width: 90,
                        height: 90,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f3f4f6",
                        borderRadius: 8,
                        fontSize: 10,
                        color: "#9ca3af",
                      }}
                    >
                      QR Not Available
                    </div>
                  )}
                </div>

                <div
                  style={{
                    marginTop: 5,
                    fontWeight: 700,
                    letterSpacing: 1.5,
                    fontSize: 13,
                    color: "#000000",
                  }}
                >
                  {qrValue}
                </div>
              </div>
            </div>

            {/* CuroNext Footer */}
            <div
              style={{
                padding: "8px 16px",
                textAlign: "center",
                background: "#ffffff",
                borderTop: "1px solid #e5e7eb",
              }}
            >
              <img
                src={CuroNextLogo}
                alt="CuroNext"
                style={{
                  height: 26,
                  objectFit: "contain",
                }}
              />
            </div>
          </div>

          {/* GAP */}
          <div style={{ height: 20 }} />

          {/* DOWNLOAD BUTTON */}
          {/* <button
            onClick={handleDownload}
            disabled={downloading}
            style={{
              width: "100%",
              padding: "14px 0",
              background: downloading ? "#5aacdf" : "#1C80D2",
              color: "#fff",
              border: "none",
              borderRadius: 12,
              fontSize: 16,
              fontWeight: 600,
              cursor: downloading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
            }}
          >
            {downloading ? (
              <>
                <div className="spinner-border spinner-border-sm text-white" role="status"
                  style={{ width: 18, height: 18, borderWidth: 2 }} />
                Generating PDF...
              </>
            ) : (
       <>
          <img
            src={DownloadIcon}
            alt="Download"
            style={{
              width: 20,
              height: 20,
              objectFit: "contain",
              filter: "brightness(0) invert(1)"
            }}
          />
          Download Pass
        </>

            )}
          </button> */}
        </div>
      </div>
    </>
  );
};

export default DigitalPassCard;